import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { Entities, ObjectType } from '../../data-rules-model';
import { ToggleGroupBtnComponent } from '../../lib/toggle-group-btn/toggle-group-btn.component';
import { IActionFieldMeta, MetaDataService, MetaSource } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-concatenate-entries',
  templateUrl: './concatenate.component.html',
  imports: [
    ToggleGroupBtnComponent,
    MatTooltip,
    ReactiveFormsModule
  ],
  styleUrls: ['./concatenate.component.scss']
})

export class ConcatenateComponent extends BaseActionComponent {

  truncWarningToolTip = 'Note: Depending on the max length of the result field,'
    + ' the length of the concatenated strings, and the length of the delimiter,'
    + ' the result string may be truncated.  ';

  delimiterValue: FormControl;
  formatGroup: FormGroup;
  @Input() primaryEntity: Entities;
  dataSourceType = MetaSource.ACTION;

  messageResult: string;
  initialMessage: string;
  errorMessage: string;
  valueArray: string[];
  concatField: Concatfields;
  parametersFormGroup1: FormGroup;
  parametersFormGroup2: FormGroup;
  parametersForm: FormArray;
  meta: Observable<IActionFieldMeta[]>;

  constructor(
    private formBuilder: FormBuilder,
    protected metaDataService: MetaDataService
  ) {
    super(metaDataService);
  }

  initialise(): void {
    this.createLocalControls();
    this.initialMessage = `${this.destinationControl.value} = `;
    this.valueArray = [];
    if (this.actionData.value) {
      this.concatField = this.actionData.value as Concatfields;
    } else {
      this.concatField = new Concatfields();
      this.concatField.parameters.push(new Parameter());
      this.concatField.parameters.push(new Parameter());
    }
    this.delimiterValue.setValue(this.concatField.delimiter);
    this.destinationControl.setValidators(Validators.required);
  }

  updateParameter(data, index) {
    if (data) {
      this.formGroup.removeControl('fieldValue' + (index + 1));
      const value = data.formGroup.value;
      if (value.type === ObjectType.FIELD) {
        this.parametersForm.removeAt(index);
        this.parametersForm.insert(index, data.formGroup);
        if (data.sourceId) {
          this.formGroup.addControl('fieldValue' + (index + 1), data.sourceId);
        }
      }
      this.concatField.parameters[index].value = value.value;
      this.valueArray[index] = this.formatEntityValue(value);
      this.updateOperationMessage();
      this.valueControlValueChange();
    }
  }

  getNewMeta(data) {
    this.meta = this.getMeta(data.secondEntity);
  }

  updateOperationMessage(): void {
    this.messageResult = this.initialMessage + this.valueArray.join(this.delimiterValue.value);
  }

  createLocalControls(): void {
    this.formatGroup = this.formBuilder.group([]);
    this.parametersForm = this.formBuilder.array([]);
    this.parametersFormGroup1 = this.formBuilder.group([]);
    this.parametersFormGroup2 = this.formBuilder.group([]);
    this.formGroup.removeControl('value');
    this.formGroup.removeControl('delimiter');
    this.formGroup.removeControl('parameters');
    this.delimiterValue = new FormControl();
    this.parametersForm.insert(0, this.parametersFormGroup1);
    this.parametersForm.insert(1, this.parametersFormGroup2);
    this.formatGroup.addControl('delimiter', this.delimiterValue);
    this.formatGroup.addControl('parameters', this.parametersForm);
    this.formGroup.addControl('value', this.formatGroup);
  }

  changeDelimiter() {
    this.updateOperationMessage();
  }

  private valueControlValueChange(): void {
    for (const i of this.concatField.parameters) {
      if (!i.value) {
        this.formatGroup.setErrors({invalid: true});
      }
    }
  }

  formatEntityValue(data) {
    let entityValue = data.value;
    if (data.sourceEntity) {
      if (data.value.indexOf('.') > 0) {
        entityValue = data.value.split('.')[1];
      }
    }
    return entityValue;
  }
}

export class Parameter {
  sourceEntity = '';
  type = ObjectType.FIELD;
  value = '';
}

export class Concatfields {
  delimiter = '';
  parameters: Parameter[] = [];
}
